import { useEffect, useState, useCallback } from 'react';
import { useBlocker } from 'react-router-dom';
/** Warns before dirty navigation and optionally prepares clean in-app exits. */
export var useUnsavedChangesWarning = function (_a) {
    var hasUnsavedChanges = _a.hasUnsavedChanges, _b = _a.isSaving, isSaving = _b === void 0 ? false : _b, _c = _a.message, message = _c === void 0 ? 'You have unsaved changes. Are you sure you want to leave? Your changes will be lost.' : _c, prepareNavigation = _a.prepareNavigation, isInternalNavigation = _a.isInternalNavigation;
    var _d = useState(false), showDialog = _d[0], setShowDialog = _d[1];
    var shouldWarn = hasUnsavedChanges || isSaving;
    var shouldBlock = shouldWarn || !!prepareNavigation;
    var blocker = useBlocker(function (_a) {
        var currentLocation = _a.currentLocation, nextLocation = _a.nextLocation;
        return shouldBlock
            && currentLocation.pathname !== nextLocation.pathname
            && !(isInternalNavigation === null || isInternalNavigation === void 0 ? void 0 : isInternalNavigation({
                currentPathname: currentLocation.pathname,
                nextPathname: nextLocation.pathname,
            }));
    });
    useEffect(function () {
        if (!shouldWarn)
            return;
        var handleBeforeUnload = function (e) {
            e.preventDefault();
            e.returnValue = message;
            return message;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function () {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [shouldWarn, message]);
    var proceed = useCallback(function () {
        setShowDialog(false);
        if (blocker.state !== 'blocked')
            return;
        if (!prepareNavigation) {
            blocker.proceed();
            return;
        }
        try {
            void Promise.resolve(prepareNavigation())
                .catch(function (error) { return console.error('Failed to prepare navigation', error); })
                .then(function () { return blocker.proceed(); });
        }
        catch (error) {
            console.error('Failed to prepare navigation', error);
            blocker.proceed();
        }
    }, [blocker, prepareNavigation]);
    useEffect(function () {
        if (blocker.state !== 'blocked')
            return;
        if (!shouldWarn) {
            proceed();
            return;
        }
        setShowDialog(true);
    }, [blocker.state, proceed, shouldWarn]);
    var handleConfirmNavigation = useCallback(function () {
        proceed();
    }, [proceed]);
    var handleCancelNavigation = useCallback(function () {
        setShowDialog(false);
        if (blocker.state === 'blocked') {
            blocker.reset();
        }
    }, [blocker]);
    return {
        showDialog: showDialog,
        handleConfirmNavigation: handleConfirmNavigation,
        handleCancelNavigation: handleCancelNavigation
    };
};
